import React from 'react'

import { Backdrop, CircularProgress } from '@mui/material'

const BackdropLoading = ({ open }) => {
  return (
    <Backdrop
      open={open}
      className='text-white z-10 bg-textDisabled'
      sx={{
        position: 'absolute',
        opacity: '0.5 !important'
      }}
    >
      <CircularProgress color='inherit' />
    </Backdrop>
  )
}

export default BackdropLoading
